import { render, staticRenderFns } from "./RightsTab.vue?vue&type=template&id=17b5a219&scoped=true&"
import script from "./RightsTab.vue?vue&type=script&lang=js&"
export * from "./RightsTab.vue?vue&type=script&lang=js&"
import style0 from "./RightsTab.vue?vue&type=style&index=0&id=17b5a219&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17b5a219",
  null
  
)

export default component.exports